import { Injectable } from '@angular/core';

import { APP_CONFIG } from '../../app.config';
import { RequestService } from '../../shared/services/request.service';
import { DisplayCard } from '../models/card/display-card.model';
import { Error } from '../models/error.model';

@Injectable()
export class PaymentService {
  constructor(private requestService: RequestService) {}

  /**
   * Carrega e atualiza a lista de cartões do usuário
   * @param iuguCustomerId
   */
  loadCards(iuguCustomerId: string): Promise<Array<DisplayCard>> {
    return new Promise((resolve, reject) => {
      const urlRequest: string = this.requestService.buildUrlPathParams(
        { iuguCustomerId: iuguCustomerId },
        APP_CONFIG.WEBSERVICE.GET_CARDS
      );
      this.requestService.getData(urlRequest).then(
        (response: any) => {
          console.log(response);
          const cards: Array<DisplayCard> = [];
          if (response && response.length > 0) {
            for (const card of response) {
              cards.push(new DisplayCard(card));
            }
          }
          resolve(cards || []);
        },
        (error: Error) => {
          console.error(error);
          reject(error);
        }
      );
    });
  }

  getCardById(iuguCustomerId: string, cardId: string): Promise<DisplayCard> {
    return new Promise((resolve, reject) => {
      const params: any = {
        iuguCustomerId: iuguCustomerId,
        cardId: cardId,
      };
      const urlRequest: string = this.requestService.buildUrlPathParams(
        params,
        APP_CONFIG.WEBSERVICE.GET_CARD_BY_ID
      );
      this.requestService.getData(urlRequest).then(
        (response: any) => {
          console.log(response);
          let card: DisplayCard;
          if (response != null) {
            card = new DisplayCard(response);
          }
          resolve(card);
        },
        (error: Error) => {
          console.error(error);
          reject(error);
        }
      );
    });
  }

  createCreditCard(iuguCustomerId: string, cardToken: string): Promise<DisplayCard> {
    return new Promise((resolve, reject) => {
      const data: any = {
        customerId: iuguCustomerId,
        token: cardToken,
        isDefault: true,
        description: 'Cartão de crédito',
        id: '',
      };
      console.log(JSON.stringify(data));
      this.requestService.postData(APP_CONFIG.WEBSERVICE.CREATE_CREDIT_CARD, data).then(
        (response: any) => {
          console.log(response);
          if (response && (response.extra_info || (response.id && response.data))) {
            resolve(new DisplayCard(response));
          } else {
            reject(new Error(412, 'Erro ao tentar salvar o cartão'));
          }
        },
        (error: Error) => {
          console.error(error);
          reject(error);
        }
      );
    });
  }

  deleteCreditCard(iuguCustomerId: string, cardId: string): Promise<void> {
    return new Promise((resolve, reject) => {
      const params: any = {
        iuguCustomerId: iuguCustomerId,
        cardId: cardId,
      };
      const urlRequest: string = this.requestService.buildUrlPathParams(
        params,
        APP_CONFIG.WEBSERVICE.DELETE_CREDIT_CARD
      );
      this.requestService.postData(urlRequest, params).then(
        (response: any) => {
          console.log(response);
          resolve();
        },
        (error: Error) => {
          console.error(error);
          reject(error);
        }
      );
    });
  }

  // AUX VALIDATION
  // -----------------------------

  getCardValidationMessageError(error: any): string {
    let errorMessage: string = '';
    // Propriedades que vem da API da IuguJS
    const errorObjTranslate: any = {
      first_name: 'Nome no cartão',
      last_name: 'Nome no cartão',
      month: 'Mês',
      year: 'Ano',
      number: 'Número do cartão',
      record_invalid: 'Número do cartão',
      verification_value: 'Código CVV',
    };
    //Trato nome e sobrenome como campo único na tela
    if (error.first_name && error.last_name) {
      delete error.last_name;
    }
    let first: boolean = true;
    for (const key in error) {
      if (errorObjTranslate[key] != null) {
        if (first) {
          first = false;
        } else {
          errorMessage += ', ';
        }
        errorMessage += errorObjTranslate[key];
      }
    }
    return errorMessage;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/payment.service.ts